import {
  FETCH_STUDENT_COURSES_REQUEST,
  FETCH_STUDENT_COURSES_SUCCESS,
  FETCH_STUDENT_COURSES_FAILURE,
} from "../Actions/adminDeveloperStudentCoursesAction";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

const studentCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_COURSES_REQUEST:
      return { ...state, loading: true };
    case FETCH_STUDENT_COURSES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: "" };
    case FETCH_STUDENT_COURSES_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default studentCoursesReducer;
